import Typography from "@portal/components/atoms/v2/typography";
import { TextResources } from "@portal/assets/text/TextResources";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import { SuccessMessage } from "@portal/components/atoms/successMessage";
import { ValidationMessage } from "@portal/components/atoms/validationMessage";
import { FC } from "react";
import { INewCashAccountProps } from "./types";
import useNewCashAccount from "@portal/hooks/useNewCashAccount";
import Input from "@portal/components/atoms/v2/input";
import { Field, Label } from "@headlessui/react";
import Button from "@portal/components/atoms/v2/buttons/button";

const NewCashAccount: FC<INewCashAccountProps> = ({ close }) => {
  const {
    createNewCashAccount,
    handleAccountNumberChange,
    handleClose,
    accountNumber,
    accountNumberError,
    apiError,
    loading,
    showCompleteMessage,
  } = useNewCashAccount();

  const handleConfirmAddAccount = async () => {
    createNewCashAccount();
  };

  return (
    <div className="space-y-3">
      <Typography variant="H6">{TextResources.NEW_CASH_ACCOUNT_SUBTITLE}</Typography>
      <InfoBoxComponent texts={[TextResources.NEW_CASH_ACCOUNT_INFO_TEXT]} />
      <Field>
        <Label>
          <Typography variant="DescriptionBold">{TextResources.NEW_CASH_ACCOUNT_NUMBER_LABEL}</Typography>
        </Label>
        <Input onChange={handleAccountNumberChange} value={accountNumber} error={!!accountNumberError} />
      </Field>
      <div className="flex py-2 justify-center md:justify-start space-x-2">
        <Button
          disabled={!!accountNumberError}
          loading={loading ? 1 : 0}
          primary
          onClick={handleConfirmAddAccount}
          text={TextResources.NEW_CASH_ADD_ACCOUNT_BUTTON_TEXT}
        />
        {close && showCompleteMessage && (
          <Button
            loading={loading ? 1 : 0}
            onClick={() => {
              handleClose();
              close();
            }}
            text={TextResources.NEW_CASH_CLOSE_BUTTON_TEXT}
          />
        )}
      </div>
      {showCompleteMessage && <SuccessMessage message={TextResources.NEW_CASH_ACCOUNT_CREATED_MESSAGE} />}
      {accountNumberError && <ValidationMessage messages={[accountNumberError]} />}
      {apiError && <ValidationMessage messages={[apiError]} />}
    </div>
  );
};

export default NewCashAccount;
